import { ArrowUp, MessageCircle, Instagram } from "lucide-react";

const WHATSAPP_NUMBER = "351960448841";
const INSTAGRAM_URL = "https://instagram.com/the_medical_architect";

export const Footer = ({ t }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleWhatsAppClick = () => {
    // Google Ads Conversion Tracking
    if (typeof gtag !== 'undefined') {
      gtag('event', 'conversion', {'send_to': 'AW-17709544469/BvIuCObJzoUcEJXoyPxB'});
    }
    window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank");
  };

  return (
    <footer data-testid="footer" className="footer-gradient py-16 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div>
            <a href="#" onClick={(e) => { e.preventDefault(); scrollToTop(); }} data-testid="footer-logo" className="text-xl font-medium tracking-tight transition-opacity hover:opacity-80" style={{ fontFamily: "'Playfair Display', serif" }}>
              <span className="text-[#E5E5E5]">The</span>{" "}
              <span className="text-gold-gradient">Medical</span>{" "}
              <span className="text-[#E5E5E5]">Architect</span>
            </a>
            <p className="text-sm text-[#A3A3A3] mt-2">{t.footer.tagline}</p>
          </div>
          <div className="flex gap-6 items-center">
            <a 
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link" 
              className="flex items-center gap-2 text-sm text-[#A3A3A3] hover:text-[#E1306C] transition-colors"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <button 
              onClick={handleWhatsAppClick}
              data-testid="footer-whatsapp-link" 
              className="flex items-center gap-2 text-sm text-[#A3A3A3] hover:text-[#25D366] transition-colors"
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </div>
          <button onClick={scrollToTop} data-testid="footer-back-to-top" className="w-12 h-12 border border-white/10 flex items-center justify-center hover:border-[#C5A059]/30 hover:bg-[#C5A059]/5 transition-all group">
            <ArrowUp className="w-4 h-4 text-[#A3A3A3] group-hover:text-[#C5A059] transition-colors" />
          </button>
        </div>
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#666]">© {new Date().getFullYear()} The Medical Architect. {t.footer.copyright}</p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-[#666] hover:text-[#A3A3A3] transition-colors">{t.footer.privacy}</a>
            <a href="#" className="text-xs text-[#666] hover:text-[#A3A3A3] transition-colors">{t.footer.terms}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
